/**
 * 销售模块路由（由店铺模块清单销售/订单记录/客户查询复制）
 */
import order from '@/views/sale/order'
import Orderdetails1 from '@/views/sale/Orderdetails1'
import orderDetails from '@/views/sale/orderDetails'

export default [
	{
		path: '/sale',
		redirect: '/sale/productIntro'
	},
	{
		path: '/sale/productIntro',
		name: 'saleProductIntro',
		meta: [{ name: '产品介绍' }],
		component: resolve => require(['@/views/sale/productIntro'], resolve)
	},
	{
		path: '/sale/productSales',
		name: 'saleProductSales',
		meta: [{ name: '清单销售' }],
		component: resolve => require(['@/views/sale/productSales'], resolve)
	},
	{
		path: '/sale/order',
		name: 'saleOrder',
		meta: [{ name: '订单记录' }],
		component: order
	},
	{
		path: '/sale/Orderdetails1',
		name: 'saleOrderdetails1',
		meta: [{ name: '客户查询' }],
		component: Orderdetails1
	},
	{
		path: '/sale/order/orderDetails',
		name: 'saleOrderDetails',
		meta: [
			{ name: '订单记录' },
			{ name: '订单记录详情' }
		],
		component: orderDetails
	},
	{
		path: '/sale/Orderdetails1/orderDetails',
		name: 'saleCustomerOrderDetails',
		meta: [
			{ name: '客户查询' },
			{ name: '订单详情' }
		],
		component: orderDetails
	},
	{
		path: '/sale/commodity',
		name: 'saleCommodity',
		meta: [{ name: '商品' }],
		component: resolve => require(['@/views/sale/commodity'], resolve)
	}
]



// WEBPACK FOOTER //
// ./src/router/sale.js